import React from "react";
import NavBar from "../Components/Navb";
import { Center } from "@chakra-ui/react";
import stles from "./About.css";
import Footer from "../Components/Footer";

import {
  Container,
  Stack,
  Flex,
  Box,
  Heading,
  Text,
  Button,
  Image,
  Icon,
  IconButton,
  createIcon,
  IconProps,
  useColorModeValue,
  AspectRatio,
} from "@chakra-ui/react";

const About = () => {
  return (
    <>
      <NavBar />
      <div className="aboutPage">
        <Box
          size="lg"
          fontSize="40px"
          textAlign={"center"}
          width={"60%"}
          margin={"auto"}
          fontFamily={"Poppins"}
        >
          Building your path to success, one step at a time with SBPathsala
          Coaching Center.
        </Box>
        <div>
          <Heading fontFamily={"cursive"} fontSize={"23px"} className="who">
            Who we are
          </Heading>
          <Text fontFamily={"Poppins"}>
            SBPathsala Coaching Center is a premier educational institute that
            provides top-notch coaching for IIT JEE Main as well as class 11th
            and 12th students. Their dedicated and experienced faculty members
            provide personalized attention to each student and help them
            understand complex concepts in a simplified manner. The institute
            has a well-structured curriculum and offers comprehensive study
            materials, online test series, and regular mock tests to help
            students prepare for their exams effectively. Their teaching
            methodology not only focuses on improving academic performance but
            also enhances students' critical thinking and problem-solving
            skills, which are essential for success in any field. Furthermore,
            SBPathsala Coaching Center offers a supportive and stimulating
            learning environment that encourages students to explore their
            potential and excel in their academic pursuits. Their innovative
            teaching techniques and constant guidance have helped numerous
            students achieve their academic goals and realize their aspirations.
          </Text>
        </div>
        <div>
          <Heading fontFamily={"cursive"} fontSize={"23px"} className="who">
            What we teach
          </Heading>
          <Text fontFamily={"Poppins"}>
            At SBPathsala Coaching Center, we strive to provide our students
            with a holistic learning experience that not only focuses on
            academic excellence but also nurtures their overall growth and
            development. We offer comprehensive coaching programs for IIT JEE
            Main as well as class 11th and 12th students, covering a wide range
            of subjects and topics. Our experienced faculty members are highly
            qualified and well-versed in their respective fields, with years of
            teaching experience under their belt. They use innovative teaching
            techniques, such as interactive classroom sessions, audio-visual
            aids, and hands-on learning activities, to make the learning
            experience engaging and effective. Our IIT JEE Main coaching program
            is designed to help students prepare for one of the most competitive
            exams in the country. We cover all the subjects and topics included
            in the JEE Main syllabus, including Mathematics, Physics, and
            Chemistry. Our study materials and online test series provide
            students with ample opportunities to practice and hone their skills,
            while our regular mock tests help them assess their performance and
            identify areas of improvement. For class 11th and 12th students, we
            offer coaching programs that cover a wide range of subjects,
            including Mathematics, Physics, Chemistry, and Biology. Our faculty
            members provide personalized attention to each student, helping them
            understand complex concepts and build a strong foundation for their
            future academic pursuits. Apart from academic coaching, we also
            focus on developing our students' critical thinking,
            problem-solving, and communication skills, which are essential for
            success in any field. We encourage our students to participate in
            extracurricular activities and events, such as debates, quizzes, and
            workshops, to enhance their overall personality and boost their
            confidence.
          </Text>
        </div>
        <div>
          <Container maxW={"7xl"}>
            <Stack
              align={"center"}
              spacing={{ base: 8, md: 10 }}
              py={{ base: 20, md: 28 }}
              direction={{ base: "column", lg: "row" }}
            >
              <Stack
                justify={"space-between"}
                flex={1}
                spacing={{ base: 5, md: 10 }}
              >
                <Heading
                  lineHeight={1.1}
                  fontWeight={600}
                  fontSize={{ base: "3xl", sm: "4xl", lg: "6xl" }}
                  fontFamily={"Poppins"}
                >
                  <Text
                    justifyContent={"start"}
                    as={"span"}
                    position={"relative"}
                    _after={{
                      content: "''",
                      width: "full",
                      height: "30%",
                      position: "absolute",
                      bottom: 1,
                      left: 0,
                      bg: "red.400",
                      zIndex: -1,
                    }}
                  >
                    YouTube
                  </Text>
                  <br />
                  <Text as={"span"} color={"red.400"}>
                    Where We Teach
                  </Text>
                </Heading>
                <Text fontSize={"20px"} fontFamily={"Poppins"}>
                  SBPathsala Coaching Center's YouTube channel is an excellent
                  resource for students who are looking for quality education
                  and guidance. Our channel offers a wide range of educational
                  videos, covering subjects such as Mathematics, Physics,
                  Chemistry, and Biology, as well as tips and tricks to help
                  students prepare for competitive exams such as IIT JEE Main.
                </Text>
                <Stack
                  spacing={{ base: 4, sm: 6 }}
                  direction={{ base: "column", sm: "row" }}
                ></Stack>
              </Stack>
              <Flex
                flex={1}
                justify={"center"}
                align={"center"}
                position={"relative"}
                w={"full"}
              >
                
                <Box
                  position={"relative"}
                  height={"300px"}
                  rounded={"2xl"}
                  boxShadow={"xl"}
                  width={"full"}
                  overflow={"hidden"}
                >
                  <AspectRatio  ratio={2}>
                    <iframe
                      title="embed-video"
                      src="https://www.youtube.com/embed/3LJAc9Hx6Ks"
                      allowFullScreen
                      width={"auto"}
                    />
                  </AspectRatio>
                </Box>
              </Flex>
            </Stack>
          </Container>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;

const PlayIcon = createIcon({
  displayName: "PlayIcon",
  viewBox: "0 0 58 58",
  d: "M28.9999 0.562988C13.3196 0.562988 0.562378 13.3202 0.562378 29.0005C0.562378 44.6808 13.3196 57.438 28.9999 57.438C44.6801 57.438 57.4374 44.6808 57.4374 29.0005C57.4374 13.3202 44.6801 0.562988 28.9999 0.562988ZM39.2223 30.272L23.5749 39.7247C23.3506 39.8591 23.0946 39.9314 22.8332 39.9342C22.5717 39.9369 22.3142 39.8701 22.0871 39.7406C21.86 39.611 21.6715 39.4234 21.5408 39.1969C21.4102 38.9705 21.3421 38.7133 21.3436 38.4519V19.5491C21.3421 19.2877 21.4102 19.0305 21.5408 18.8041C21.6715 18.5776 21.86 18.3899 22.0871 18.2604C22.3142 18.1308 22.5717 18.064 22.8332 18.0668C23.0946 18.0696 23.3506 18.1419 23.5749 18.2763L39.2223 27.729C39.4404 27.8619 39.6207 28.0486 39.7458 28.2713C39.8709 28.494 39.9366 28.7451 39.9366 29.0005C39.9366 29.2559 39.8709 29.507 39.7458 29.7297C39.6207 29.9523 39.4404 30.1391 39.2223 30.272Z",
});

export const Blob = () => {
  return (
    <Icon
      width={"100%"}
      viewBox="0 0 578 440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M239.184 439.443c-55.13-5.419-110.241-21.365-151.074-58.767C42.307 338.722-7.478 282.729.938 221.217c8.433-61.644 78.896-91.048 126.871-130.712 34.337-28.388 70.198-51.348 112.004-66.78C282.34 8.024 325.382-3.369 370.518.904c54.019 5.115 112.774 10.886 150.881 49.482 39.916 40.427 49.421 100.753 53.385 157.402 4.13 59.015 11.255 128.44-30.444 170.44-41.383 41.683-111.6 19.106-169.213 30.663-46.68 9.364-88.56 35.21-135.943 30.551z"
        fill="currentColor"
      />
    </Icon>
  );
};
